import ApplicationComponent from "legacy/ApplicationComponent"
import LegacyButton from "legacy/LegacyButton"
import moment from "moment"
import PropTypes from "prop-types"
import React from "react"

class AssignmentsDateButtons extends ApplicationComponent {
  renderVisibleDates() {
    const daysArray = this.props.visibleRange.daysArray
    const start = moment(this.props.visibleRange.daysArray[0]).format(
      "MMMM D, YYYY"
    )
    const end = moment(daysArray[daysArray.length - 1]).format("MMMM D, YYYY")
    return (
      <div className="flex w-full items-center justify-center font-semibold">
        {start === end ? (
          <span>{start}</span>
        ) : (
          <span>
            {start} - {end}
          </span>
        )}
      </div>
    )
  }

  render() {
    const dayString = this.props.dayIncrement === 1 ? "day" : "days"

    return (
      <div className="flex space-x-2">
        <LegacyButton
          type="tertiary"
          icon="fa-arrow-left"
          iconStyle="solid"
          iconOnly={true}
          onClick={this.props.moveBackward}
          title={`Backward ${this.props.dayIncrement} ${dayString}`}
        />
        {this.renderVisibleDates()}
        <LegacyButton
          type="tertiary"
          icon="fa-arrow-right"
          iconStyle="solid"
          iconOnly={true}
          onClick={this.props.moveForward}
          title={`Forward ${this.props.dayIncrement} ${dayString}`}
        />
      </div>
    )
  }
}

AssignmentsDateButtons.propTypes = {
  dayIncrement: PropTypes.number.isRequired,
  moveBackward: PropTypes.func.isRequired,
  moveForward: PropTypes.func.isRequired,
  visibleRange: PropTypes.object.isRequired,
}

export default AssignmentsDateButtons
